<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{ priorityList?.id ? "Modifica" : "Nuovo"}} Priorità Lista</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container"></span>
    </div>
  </div>
</section>

<section class="content-padding darker">
    <div class="narrow-wrapper">
      <form class="has-cols" [formGroup]="priorityListForm" *ngIf="priorityListForm" (ngSubmit)="onSubmit()">

        <fieldset>
          <legend>Prodotto & Provincia</legend>
          <div class="col-48 grid-element">
            <label style="position: relative; top: 20px;">Scegli la Categoria Prodotto</label>
            <div>
              <div class="offer-products">
                <div class="" style="display: table; width: 100%;">
                  <label for=""></label>
                  <div style="display: table-cell; width: 19px;">
                    <i class="far fa-times-circle hvr-grow remove-product"></i>
                  </div>
                  <div class="product-q">
                    <div class="porduct-qty">
                      <div class="province-input">
                        <label for=""></label>
                        <ng-select formControlName="productCategory">
                            <ng-option *ngFor="let productCategory of productCategories" [value]="productCategory.id">
                              {{ productCategory?.categoryName }}
                            </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <app-error-html-handler [ctrl]="priorityListForm.get('productCategory')" [messages]="formValidationMsgs.productCategory"></app-error-html-handler>
                </div>
              </div>
            </div>
          </div>

          <div class="col-48 grid-element">
              <label style="position: relative; top: 20px;">Scegli la Provincia</label>
              <div>
                <div class="offer-products">
                  <div class="" style="display: table; width: 100%;">
                    <label for=""></label>
                    <div style="display: table-cell; width: 19px;">
                      <i class="far fa-times-circle hvr-grow remove-product"></i>
                    </div>
                    <div class="product-q">
                      <div class="porduct-qty">
                        <div class="province-input">
                          <label for=""></label>
                          <ng-select formControlName="province">
                              <ng-option *ngFor="let province of provinces" [value]="province.id">
                                  <b>{{ province?.provinceCode }}</b> {{ province?.province }}
                              </ng-option>
                          </ng-select>
                        </div>
                      </div>
                    </div>
                    <br>
                    <app-error-html-handler [ctrl]="priorityListForm.get('province')" [messages]="formValidationMsgs.province"></app-error-html-handler>
                  </div>
                </div>
              </div>
          </div>
        </fieldset>

        <fieldset style="margin-top: 15px;">
          <legend>Partner</legend>
          <div class="grid-element-full">
            <label style="position: relative; top: 20px;">Seleziona il Partner</label>
            <div>
              <div class="offer-products">
                <div class="" style="display: table; width: 100%;">
                  <div class="product-q">
                    <div class="porduct-qty">
                      <div class="province-input"> 
                        <label for=""></label>
                        <ng-select 
                          [(ngModel)]="selectedPartner" 
                          [ngModelOptions]="{standalone: true}"
                          [searchable]="true" 
                          [clearable]="true"
                          [virtualScroll]="true"
                        >
                            <ng-option *ngFor="let partner of partners" [value]="partner.id">
                                {{ partner?.businessName }}
                            </ng-option>
                        </ng-select>
                      </div>
                    </div>
                  </div>
                  <br>
                  <!-- <app-error-html-handler [ctrl]="priorityListForm.get('partnerPriorities')" [messages]="formValidationMsgs.partnerPriorities"></app-error-html-handler> -->
                </div>
              </div>
            </div>
            <div class="center" style="width: 100%;">
              <button class="btn mt-0" (click)="$event.preventDefault(); addPartnerInDropList()">
                Aggiungi Partner<i class="ml-10 fas fa-plus"></i>
              </button>
            </div>
          </div>

          <!-- Drag and Drop -->
          <div cdkDropList class="example-list mt-20" (cdkDropListDropped)="drop($event)">  
            <div class="example-box" *ngFor="let partner of dragAndDropPartnersList, index as i" cdkDrag>
              <div class="drag-index">{{ i+1 }}</div>
                <div class="w-10 drag-icon">
                  <i class="material-icons" cdkDragHandle>reorder</i>
                </div>
                <div class="w-100 drag-content">
                  {{ partner?.businessName }}
                </div> 
                <div class="w-10 delete-icon">
                  <button mat-icon-button>
                    <i class="material-icons" (click)="removePartnerFromDropList(i, partner?.id)">delete_outline</i>
                  </button>
                </div>
            </div>
          </div>
          <!-- Drag and Drop -->
        </fieldset>
  
        <div class="center" style="margin-top: 10px;">
          <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!priorityListForm.valid">
            Salva<i class="ml-10 far fa-save"></i>
          </button>
        </div>
        <div class="center" style="margin-top: 10px;">
          <button type="button" [routerLink]="['/partner/priority/list/duplica', priorityList?.id]" class="btn hvr-shrink center">
            Duplica<i class="ml-10 far fa-save"></i>
          </button>
        </div>
        
      </form>
      <br class="clear">
    </div>
</section>